import ErrorIcon from '@assets/icons/error.svg?react';
import InfoIcon from '@assets/icons/info.svg?react';
import SuccessBoxIcon from '@assets/icons/success-box.svg?react';
import WarningIcon from '@assets/icons/warning.svg?react';
import { Alert, AlertProps as MUIAlertProps, styled } from '@mui/material';

type AlertProps = MUIAlertProps & {
    noStyle?: boolean;
};

const Info = styled(({ noStyle, ...props }: AlertProps) => (
    <Alert
        {...props}
        severity="info"
        icon={<InfoIcon />}
        slotProps={{
            ...(noStyle
                ? {
                      root: {
                          sx: {
                              bgcolor: 'transparent !important',
                          },
                      },
                  }
                : {}),
            message: {
                sx: {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 12,
                    color: (theme) => theme.palette['light-toast-message'].main,
                },
            },
        }}
    />
))(({ theme, noStyle }) =>
    noStyle
        ? {}
        : {
              borderRadius: '8px',
              backgroundColor: theme.palette['light-informative-background'].main,
              border: `1px solid ${theme.palette['light-informative-border'].main}`,
          }
);

const Error = styled(({ noStyle, ...props }: AlertProps) => (
    <Alert
        {...props}
        severity="error"
        icon={<ErrorIcon />}
        slotProps={{
            ...(noStyle
                ? {
                      root: {
                          sx: {
                              bgcolor: 'transparent !important',
                          },
                      },
                  }
                : {}),
            message: {
                sx: {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 12,
                    color: (theme) => theme.palette['light-toast-message'].main,
                },
            },
        }}
    />
))(({ theme, noStyle }) =>
    noStyle
        ? {}
        : {
              borderRadius: '8px',
              backgroundColor: theme.palette['light-error-background'].main,
              border: `1px solid ${theme.palette['light-error-border'].main}`,
          }
);

const Success = styled(({ noStyle, ...props }: AlertProps) => (
    <Alert
        {...props}
        severity="success"
        icon={<SuccessBoxIcon />}
        slotProps={{
            ...(noStyle
                ? {
                      root: {
                          sx: {
                              bgcolor: 'transparent !important',
                          },
                      },
                  }
                : {}),
            message: {
                sx: {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 12,
                    color: (theme) => theme.palette['light-toast-message'].main,
                },
            },
        }}
    />
))(({ theme, noStyle }) =>
    noStyle
        ? {}
        : {
              borderRadius: '8px',
              backgroundColor: theme.palette['light-success-background'].main,
              border: `1px solid ${theme.palette['light-success-border'].main}`,
          }
);

const Warning = styled(({ noStyle, ...props }: AlertProps) => (
    <Alert
        {...props}
        severity="warning"
        icon={<WarningIcon />}
        slotProps={{
            ...(noStyle
                ? {
                      root: {
                          sx: {
                              bgcolor: 'transparent !important',
                          },
                      },
                  }
                : {}),
            message: {
                sx: {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 12,
                    color: (theme) => theme.palette['light-toast-message'].main,
                },
            },
        }}
    />
))(({ theme, noStyle }) =>
    noStyle
        ? {}
        : {
              borderRadius: '8px',
              backgroundColor: theme.palette['light-warning-background'].main,
              border: `1px solid ${theme.palette['light-warning-border'].main}`,
          }
);

export const AlertNamespace = Object.assign(Info, {
    Info,
    Error,
    Success,
    Warning,
});

export { AlertNamespace as Alert };
